(function () {
  'use strict';

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function refreshSlider(node) {
    var slider = node && node.closest('slider-component');
    if (!slider) return;
    slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');
    if (typeof slider._wake === 'function') slider._wake();
    window.dispatchEvent(new Event('resize'));
  }

  function fillSlot(slot, nodes) {
    if (!nodes.length) return;
    if (slot.tagName === 'UL') {
      slot.innerHTML = '';
      nodes.forEach(function (node) { slot.appendChild(node); });
      slot.classList.remove('js-lazy-tab-slot');
      refreshSlider(slot);
      return;
    }
    slot.replaceWith.apply(slot, nodes);
    refreshSlider(nodes[0]);
  }

  function loadTab(slot) {
    if (!slot || slot.dataset.loaded === '1' || !slot.dataset.src) return;
    slot.dataset.loaded = '1';
    fetch(slot.dataset.src, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(); })
      .then(function (html) {
        var list = parseHtml(html).querySelector('[data-ajax-cards]');
        if (!list) return;
        fillSlot(slot, Array.prototype.slice.call(list.children));
      })
      .catch(function () {
        slot.dataset.loaded = '0';
      });
  }

  function loadAllPending() {
    document.querySelectorAll('.js-lazy-tab-slot').forEach(loadTab);
  }

  function init() {
    document.addEventListener('click', function (event) {
      var tab = event.target.closest('.tab-js, .component-tabs__tab');
      if (!tab || !tab.id) return;
      var panel = document.getElementById('content-' + tab.id);
      if (!panel) return;
      panel.querySelectorAll('.js-lazy-tab-slot').forEach(loadTab);
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAllPending, { timeout: 1500 });
    } else {
      window.setTimeout(loadAllPending, 800);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
